import React, {useContext} from "react";
import {MessageBottomContainerContext} from "../Message.tsx";
import UserContainer from "./UserContainer/UserContainer.tsx";
import AiContainer from "./AiContainer/AiContainer.tsx";

interface MessageBottomContainerProps {}

const MessageBottomContainer: React.FC<MessageBottomContainerProps> = ({}) => {
    const { group } = useContext(MessageBottomContainerContext);
    const Container = group.groupRole === "user" ? UserContainer : AiContainer;

    return (
        <div className={`flex ${group.groupRole === "user" ? "justify-end mr-2" : "justify-start ml-2"}`}>
            <Container />
        </div>
    );
}

export default MessageBottomContainer;